import Dropdown from '../components/dropdown';

export default function contact() {
	setupDropdowns();

	var inputs = [...document.querySelectorAll(`input[name=enquiryType]`), ...document.querySelectorAll(`input[name=enquirySector]`)];
	if (!inputs.length) return false;
	[...inputs].forEach(input => input.value = 'N/A');
}

function addValue(inputName = '', value) {
	if (!inputName.length) return false;
	var inputs = document.querySelectorAll(`input[name=${inputName}]`);
	if (!inputs.length) return false;
	[...inputs].forEach(input => input.value = value);
}





function setupDropdowns() {
	const dropdownElements = document.querySelectorAll('.contact-options .dropdown');

	[...dropdownElements].forEach(dropdownElement => {
		const dropdown = new Dropdown(dropdownElement);
		dropdown.addEventListener('optionChosen', ({ detail }) => firstLevelDropdownAction(detail));
	})

	function firstLevelDropdownAction(detail) {
		document.querySelector('.intro-text').classList.add('is-closed');
		var sectionToShow = detail.sectionEl;
		var optionValue = detail.optionValue;
		var hiddenInputName;
		if (sectionToShow) {
			hiddenInputName = 'enquiryType';

			[...document.querySelectorAll('.contact-section')].forEach(el => el.classList.remove('is-open'));
			sectionToShow.classList.add('is-open');
		} else if (optionValue && optionValue.length) {
			hiddenInputName = 'enquirySector';

			var dryWasteSection = jQuery('.dry-waste-postcode-form');
			if (optionValue === 'dry waste') {
				dryWasteSection.slideDown();
			} else {
				dryWasteSection.slideUp();
			}
		}

		addValue(hiddenInputName, optionValue);
	}
}

